import { type ReactNode } from 'react'

/**
 * 各画面の上部ヘッダ (タイトル + サブ + アクション + タブ)。
 * design/js/components.jsx:123-137 を移植。
 *
 * tabs はオプション。各 tab は { key, label, n? } で n は数値バッジ (省略可)。
 */
export interface PageHeadTab {
  key: string
  label: string

  /** 右側に出る数値 (件数など)。null/undefined なら非表示。 */
  n?: number
}

export interface PageHeadProps {
  title: ReactNode
  sub?: ReactNode
  actions?: ReactNode
  tabs?: readonly PageHeadTab[]
  activeTab?: string
  onTab?: (key: string) => void
  /** タブの直前 (`.ph-tabs` の上) に挿入する補助ナビ。Tools sub-nav 等で利用。 */
  beforeTabs?: ReactNode
}

export const PageHead = ({
  title,
  sub,
  actions,
  tabs,
  activeTab,
  onTab,
  beforeTabs,
}: PageHeadProps): JSX.Element => (
  <div className="page-head">
    <div className="ph-top">
      <div>
        <h1>{title}</h1>
        {sub != null && <div className="ph-sub">{sub}</div>}
      </div>
      {actions != null && <div className="ph-actions">{actions}</div>}
    </div>
    {beforeTabs}
    {tabs && tabs.length > 0 && (
      <div className="ph-tabs">
        {tabs.map(t => (
          <button
            key={t.key}
            type="button"
            className={`ph-tab${t.key === activeTab ? ' active' : ''}`}
            onClick={() => onTab?.(t.key)}
          >
            {t.label}
            {t.n != null && <span className="n">{t.n}</span>}
          </button>
        ))}
      </div>
    )}
  </div>
)
